/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the rotor's maximum radius — the distance in centimetres from the rotor centre to the bottom of the tube — unless your protocol specifies otherwise.`)
};

const es_gf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa el radio máximo del rotor — la distancia en centímetros desde el centro del rotor hasta el fondo del tubo — salvo que tu protocolo indique lo contrario.`)
};

const de_gf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwenden Sie den maximalen Rotorradius — den Abstand in Zentimetern von der Rotormitte bis zum Boden des Röhrchens —, sofern Ihr Protokoll nichts anderes vorgibt.`)
};

const nl_gf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebruik de maximale straal van de rotor — de afstand in centimeter van het rotormidden tot de onderkant van de buis — tenzij uw protocol iets anders aangeeft.`)
};

const fr_gf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisez le rayon maximal du rotor — la distance en centimètres entre le centre du rotor et le fond du tube — sauf indication contraire du protocole.`)
};

const it_gf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usa il raggio massimo del rotore — la distanza in centimetri dal centro del rotore al fondo della provetta — salvo diversa indicazione del protocollo.`)
};

const pt_br2_gf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use o raio máximo do rotor — a distância em centímetros do centro do rotor até o fundo do tubo — a menos que seu protocolo indique outra coisa.`)
};

const pt_gf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use o raio máximo do rotor — a distância em centímetros entre o centro do rotor e o fundo do tubo — a menos que o protocolo indique outra coisa.`)
};

const ja_gf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロトコルに特別な指定がない限り、ローター中心からチューブ底までの距離であるローターの最大半径(センチメートル)を使用してください。`)
};

const zh_gf_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`除非方案另有说明，应使用转子的最大半径——即从转子中心到试管底部的距离（厘米）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_faq_a3", locale)
	if (locale === "en") return en_gf_faq_a3(inputs)
	if (locale === "es") return es_gf_faq_a3(inputs)
	if (locale === "de") return de_gf_faq_a3(inputs)
	if (locale === "nl") return nl_gf_faq_a3(inputs)
	if (locale === "fr") return fr_gf_faq_a3(inputs)
	if (locale === "it") return it_gf_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_gf_faq_a3(inputs)
	if (locale === "pt") return pt_gf_faq_a3(inputs)
	if (locale === "ja") return ja_gf_faq_a3(inputs)
	return zh_gf_faq_a3(inputs)
};